import {
	EventEmitterListener,
	EventEmitterListenersList,
	EventEmitterName
} from "@/modules/Event/interface";

class EventEmitter {

	protected listeners: EventEmitterListenersList = {}

	addListener(eventName: EventEmitterName, listener: EventEmitterListener): this {
		if (this.hasEventName(eventName)) {
			this.getEventListenersArray(eventName).push(listener);
		} else {
			this.listeners[eventName] = [ listener ];
		}

		return this;
	}

	removeListener(eventName: EventEmitterName, listener: EventEmitterListener): this {
		const listeners = this.getEventListenersArray(eventName);
		const listenerIndex: number = listeners.indexOf(listener);

		if (listenerIndex > -1) {
			listeners.splice(listenerIndex, 1);
		}

		return this;
	}

	emit<T>(eventName: EventEmitterName, data?: T): this {
		this.getEventListenersArray(eventName)
			.forEach(listener => listener(data));

		return this;
	}

	hasEventName(eventName: EventEmitterName): boolean {
		return this.listeners.hasOwnProperty(eventName);
	}

	getEventListenersArray(eventName: EventEmitterName): EventEmitterListener[] {
		return this.hasEventName(eventName)
			? this.listeners[eventName]!
			: [];
	}

}

export default new EventEmitter();